module.exports = __webpack_public_path__ + "open-sans-latin-700.2e00b2635b51ba336b4b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700.svg
// module chunks = 1 3